import { render, staticRenderFns } from "./deleteReserveDining.vue?vue&type=template&id=70b5d074&scoped=true"
import script from "./deleteReserveDining.vue?vue&type=script&lang=js"
export * from "./deleteReserveDining.vue?vue&type=script&lang=js"
import style0 from "./deleteReserveDining.vue?vue&type=style&index=0&id=70b5d074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5d074",
  null
  
)

export default component.exports